// CountdownTimer.js
import React, { useState, useEffect } from 'react';
import { Typography, Box, Tooltip } from '@mui/material'; // Import Box and Tooltip
import AccessTimeIcon from '@mui/icons-material/AccessTime'; // Import clock icon

const CountdownTimer = ({ targetTime, tooltipPrefix = "Time remaining:", wrapper = "Box" }) => { // Add wrapper prop
  const [remaining, setRemaining] = useState(Math.max(0, targetTime - Date.now()));

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.max(0, targetTime - Date.now()));
    }, 1000);
    return () => clearInterval(interval);
  }, [targetTime]);

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const minutesRemaining = Math.floor(remaining / (1000 * 60));
  let textColor = 'inherit';
  if (remaining > 0) {
    if (minutesRemaining < 1) {
      textColor = 'error.main';
    } else if (minutesRemaining < 5) {
      textColor = 'warning.main';
    }
  }

  const formattedTime = formatTime(remaining);

  const WrapperComponent = wrapper === "span" ? "span" : Box;

  return (
    <Tooltip title={`${tooltipPrefix} ${formattedTime}`}>
      <WrapperComponent sx={{ display: 'inline-flex', alignItems: 'center', color: textColor }}>
        <AccessTimeIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
        <Typography variant="body2" component="span">
          {formattedTime}
        </Typography>
      </WrapperComponent>
    </Tooltip>
  );
};

export default CountdownTimer;
